define.alias("shared/components/shared/date-picker", "media/components/shared/date-picker");